module.exports = "/_next/static/images/ac1c115bc9a7c8e7c7a6d572f30aede5-footer-fogafin-4x.png";